export const DiscountCard = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="3" y="7" width="26" height="18" rx="1" stroke="currentColor" stroke-width="2"/>
  <circle cx="11" cy="13" r="2" stroke="currentColor" stroke-width="2"/>
  <circle cx="21" cy="19" r="2" stroke="currentColor" stroke-width="2"/>
  <path d="M21 11L10.9427 21.0573" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
</svg>`;
